import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from '@app/_services/shared.service';

@Injectable()
export class CountryInterceptor implements HttpInterceptor {
    constructor(private sharedService: SharedService) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const selectedCountry = this.sharedService.selectedCountry;
    
        if (selectedCountry) {
            // Encode non-ASCII characters (like Arabic) to be safe for HTTP headers
            const encodeHeaderValue = (value: string): string => {
                if (!value) return '';
                try {
                    // Use encodeURIComponent to handle non-ASCII characters
                    return encodeURIComponent(value);
                } catch (e) {
                    console.error('Failed to encode header value:', e);
                    return '';
                }
            };

            // Clone the request and add country headers
            request = request.clone({
                setHeaders: {
                    'X-Country-Id': selectedCountry._id || '',
                    'X-Country-Code': selectedCountry.code || '',
                    'X-Country-Name-En': encodeHeaderValue(
                        selectedCountry.name?.en || ''
                    ),
                    'X-Country-Name-Ar': encodeHeaderValue(
                        selectedCountry.name?.ar || ''
                    ),
                    'X-Country-Currency-Symbol': encodeHeaderValue(
                        selectedCountry.currency?.symbol || ''
                    ),
                    'X-Country-Currency-Id': selectedCountry.currency?._id || ''
                }
            });
        }

        return next.handle(request);
    }
}
